// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"3942a842","433":"71fbae5e","659":"abe1cf3e","884":"7ebf811c"}[chunkId] + ".chunk.js";
};